import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

const ProtectedRouteFaculty = ({ children }) => {
  const { facultyUser } = useAuth();

  if (!facultyUser) {
    return <Navigate to="/faculty-login" replace />;
  }

  return children;
};

export default ProtectedRouteFaculty;
